import { createContext, Dispatch, ReactNode, SetStateAction } from "react";

export const DashboardBannerContext = createContext<{
  // ReactNode (not just string) so a banner can embed a real link (e.g. SearchInterest.tsx's own
  // "follow the steps on this link" banner) rather than only ever showing plain text.
  bannerText: ReactNode;
  setBannerText: Dispatch<SetStateAction<ReactNode>>;
  detailText: string;
  setDetailText: Dispatch<SetStateAction<string>>;
  showBanner: boolean;
  setShowBanner: Dispatch<SetStateAction<boolean>>;
  bannerHovered: boolean;
  setBannerHovered: Dispatch<SetStateAction<boolean>>;
  region: string;
  setRegion: Dispatch<SetStateAction<string>>;
}>({
  bannerText: "",
  setBannerText(): void {},
  detailText: "",
  setDetailText(): void {},
  showBanner: false,
  setShowBanner(): void {},
  bannerHovered: false,
  setBannerHovered(): void {},
  region: "",
  setRegion(): void {},
});
